function addDomEvent(target, eventName, handler) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    passive: true
  };
  target.addEventListener(eventName, handler, options);
  return function () {
    return target.removeEventListener(eventName, handler);
  };
}
export { addDomEvent };